<template>
  <v-container>
    <v-dialog v-model="dialogSuccess" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">Cita reservada exitosamente</p>
          <p class="text-center">
            Te hemos enviado un email de confirmación
          </p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn to="/mis-citas" color="primary" class="container">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogFailure" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">{{errorMessage}}</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn to="/" color="primary">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="loading">
      <p class="text-center font-weight-light mt-4">Cargando datos de la cita</p>
    </div>
    <div v-else>
      <div v-if="notFound" class="d-flex flex-column align-items-center">
        <v-icon color="error" size="80" class="mt-8">report</v-icon>
        <p
          class="text-center font-weight-light mt-4"
        >La cita que buscas ya no se encuentra disponible</p>
        <v-btn text to="/" class="mb-4" color="primary">Buscar otra cita</v-btn>
      </div>
      <div v-else></div>
    </div>

    <v-stepper v-model="currentStep" vertical v-if="hour">
      <v-stepper-step :complete="false" step="1">
        Confirmar datos cita
      </v-stepper-step>

      <v-stepper-content step="1">
        <div class="d-flex justify-center mb-4">
          <professional-avatar v-bind:id-professional="hour.professional.id" v-bind:size="80"></professional-avatar>
        </div>
        <p class="text-center primary--text title">{{hour.professional.fullName}}</p>
        <p class="text-center primary--text title">
          <v-chip
            v-for="(agreement, $index) in agreementList"
            :key="$index"
            small
            class="ma-2"
            outlined
            pill
          >{{agreement.name}}</v-chip>
        </p>

        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Especialidad</v-list-item-title>
              <v-list-item-subtitle>{{hour.specialty.name}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Fecha</v-list-item-title>
              <v-list-item-subtitle>{{hour.date}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Hora</v-list-item-title>
              <v-list-item-subtitle>{{hour.start}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <!-- Identificación del paciente: solo el RUT. El resto de los datos
             se resuelven en backend desde el token de reserva y no viajan
             por el cliente (privacidad). -->
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Paciente</v-list-item-title>
              <v-list-item-subtitle>
                <template v-if="isLoggedIn">{{userFullName}}<br></template>
                RUT: {{patientRut}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <br />
        <v-btn
          color="primary"
          @click="takeHour()"
          :loading="taking"
          class="mr-2"
        >Completar reserva</v-btn>
        <v-btn text to="/">Volver</v-btn>
      </v-stepper-content>

    </v-stepper>
  </v-container>
</template>

<script>
import { formatRut } from "../utils/rut";

export default {
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    userFullName: function() {
      return this.$store.getters.getUserFullName;
    },
    myAccount() {
      return this.$store.getters.getUser;
    },
    patientRut() {
      const temporaryPatient = this.$store.getters.getTemporaryPatient;
      if (temporaryPatient && temporaryPatient.rut) {
        return formatRut(temporaryPatient.rut);
      }
      const user = this.$store.getters.getUser || {};
      return user.rut ? formatRut(user.rut) : "";
    }
  },
  data: () => ({
    currentStep: 1,
    hour: null,
    loading: true,
    taking: false,
    notFound: false,
    dialogSuccess: false,
    dialogFailure: false,
    errorMessage: 'La cita ya no se encuentra disponible',
    agreementList: []
  }),
  methods: {
    async getHour() {
      const axios = require("axios");

      let { data } = await axios.post("getHour", {
        idHour: this.$route.params.id
      });
      this.loading = false;
      if (!data) {
        this.notFound = true;
        return;
      }

      this.hour = data;
      if (this.hour.professional) {
        let { data: agreementList } = await axios.post(
          "getProfessionalAgreementList",
          {
            idProfessional: this.hour.professional.id
          }
        );
        this.agreementList = agreementList;
      }
    },
    async takeHour() {
      // El backend identifica al paciente por el token de reserva (header
      // x-booking-token) o su sesión: solo viajan idHour y comentario.
      this.taking = true;
      try {
        const axios = require("axios");
        await axios.post("takehour", {
          idHour: this.hour.id,
          comment: this.comment || ''
        });
        this.dialogSuccess = true;
      } catch (err) {
        this.dialogSuccess = false;
        this.errorMessage =
          (err.response && err.response.data && err.response.data.error) ||
          'La cita ya no se encuentra disponible';
        this.dialogFailure = true;
      } finally {
        this.taking = false;
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "Reservar cita") {
        this.hour = null;
        this.getHour();
      }
      if (from.name == "Reservar cita") {
        this.hour = null;
      }
    }
  },
  mounted() {
    // Exigir una identificación vigente: token de reserva o sesión
    const identified =
      this.$store.getters.hasBookingSession || this.$store.getters.isLoggedIn;

    if (!identified || !this.$route.query.hasPatientData) {
      this.$router.push('/');
      return;
    }

    this.getHour();
  }
};
</script>

<style>
</style>
